export default __webpack_public_path__ + "static/media/042-dining-table.e032c578.svg";